"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var click_outside_directive_1 = require("./click-outside.directive");
exports.ClickOutsideDirective = click_outside_directive_1.ClickOutsideDirective;
var click_outside_module_1 = require("./click-outside.module");
exports.ClickOutsideModule = click_outside_module_1.ClickOutsideModule;



//////////////////
// WEBPACK FOOTER
// /Users/pakornduangtrakan/Snocko/other/backend-auto/node_modules/ng-click-outside/lib/index.js
// module id = ../../../../ng-click-outside/lib/index.js
// module chunks = vendor